<template>
    <article v-if="item" class="donate-item">
        <div class="col">
            <!-- <router-link :to="link"></router-link> -->
            <h2 class="post-title">
                <strong v-html="title"></strong>
                <span v-if="price" v-html="price"></span>
            </h2>
            <Content v-html="item.post_content" />

      
            <div class="add-to-cart" :class="[{'actived': is_in_stock}]" @click="addToCart">
                <span>Add to Cart</span>
            </div>
        </div>
    </article>
</template>

<script>
import Content from '@/components/ui/Content.vue';
import { EventBus } from '@/events/bus.js';

export default {
    name: 'donate-item',

    props: {
        item: {
            type: Object,
            default: false,
        },
    },

    data() {
        return {
            img: '',
            title: '',
            link: '',
            price: '',
            is_in_stock: false,
            product_id: '',
        }
    },

    components: {
        Content,
    },

    methods: {

        addToCart() {
            if (!this.is_in_stock || !this.product_id || this.is_add_to_cart) return;
            this.is_add_to_cart = true;
            this.$cart('add-item', { 
                method: 'post',
                data: {
                    product_id: this.product_id,
                    quantity: this.quantity,
                },
            }).then((response) => {
                this.is_add_to_cart = false;
                this.$store.state.is_show_loading = false;

                EventBus.$emit('cart.open', true);
            }).catch(error => {
                console.log(error)
                // this.error_msg = error.response.data.message;
                this.is_add_to_cart = false;
                this.$store.state.is_show_loading = false;

                setTimeout(() => {
                    this.error_msg = false;
                }, 3000);
            });
        },
    },

    mounted() {
        if (this.item.post_title) {
            this.title = this.item.post_title;
        } else {
            this.title = this.item.title.rendered;
        }
        
        this.link = this.item.link.replace(window.globals.home_url, this.$base_url);
        this.img = this.item.featured_image.medium;
        this.price = '£' + Number(this.item.price).toFixed(2);
        this.product_id = this.item.ID.toString();

        if (this.item.stock_status === 'outofstock') {
            this.is_in_stock = false;
        } else {
            this.is_in_stock = true;
        }
        // console.log(this.item)

    },
}
</script>

<style lang="scss">
    .donate-item {
        position: relative;
        // background: white;
        width: 50%;
        box-sizing: border-box;
        padding: var(--padding-50);

        .col {
            box-sizing: border-box;
            font-size: var(--small-size);
            border: var(--line-2) solid;
            padding: var(--padding-50);
            background: white;
            min-height: 100%;
            display: grid;
            grid-template-rows: auto 1fr auto;
            grid-template-columns: 100%;
        }

        .post-title {
            margin: 0 0 var(--padding-50) 0;
            font-size: var(--large-size);
            display: flex;

            strong {
                flex: 1;
            }
        }

        .ui-enter {
            margin: 0 0 var(--padding) 0;
            padding: 0;
        }

        .add-to-cart {

            span {
                display: inline-block;
                font-size: var(--title-size);
                padding: .3rem 1rem;
                color: var(--gray);
                background: var(--light-gray);
            }

            &.actived {
                span {
                    color: var(--font-color);
                    background: var(--orange);
                    cursor: pointer;
                }
            }
        }

    }

    @media only screen and (max-width: 767px) {
        .donate-item {
            width: 100%;

            .col {
                font-size: var(--large-size);
            }

            .post-title {
                font-size: var(--title-size);
            }


            .add-to-cart {

                span {
                    padding: 1rem 3rem;
                }
            }

        }

    }

</style>
